import { inject, Injectable, signal } from '@angular/core';
import { FortiFACBaseProvisioningService } from './base-provisioning.service';
import { LoggerService, LogLevel } from 'app/services/logger.service';

@Injectable({
    providedIn: 'root'
})
export class AdminService extends FortiFACBaseProvisioningService {
    private readonly _isAuthenticated = signal<boolean>(false);
    public readonly isAuthenticated = this._isAuthenticated.asReadonly();
    private loggerService = inject(LoggerService);
    private logger = inject(LoggerService).getScopedLogger('AdminService');

    constructor() {
        super()
        this.loggerService.setLogLevel('AdminService', LogLevel.WARN);
        this.logger = this.loggerService.getScopedLogger('AdminService');
    }


    public setAuthenticated(): void {
        this.logger.debug('Setting authenticated = true');
        this._isAuthenticated.set(true);
    }

    public clearAuthenticated(): void {
        this.logger.debug('Clearing authentication state');
        this._isAuthenticated.set(false);
    }
}
